import React, { useState, useEffect } from "react";

import { CheckedLogin } from "./services/CheckedLogin";

import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

import { GetStatusGlobal, RegisterStatusGlobal } from "./interface/Global";

import Comp_Header from "./components/Header";
import Comp_Loading from "./components/Loading";
import Page_Sidebar from "./components/Sidebar";
import Comp_PageName from "./components/PageName";

import { PopUp_Confirmation, PopUp_InfGraffic, PopUp_ListVersion, PopUp_ReturnResponse, PopUp_ShowFile, PopUp_UpdateSite, PopUp_CreationTime, PopUp_ZoomMap, PopUp_GraphData } from "./components/PopUp";

import Page_Login from "./page/Login";
import Page_Index from "./page/Index";
import Page_Reports from "./page/Reports";

import Page_Update from "./page/Update";
import Page_Update_Details from "./page/Update/Details";

import Page_Projects from "./page/Projects";
import Page_Projects_Details from "./page/Projects/Details";

import Page_Clients from "./page/Clients";
import Page_Clients_Details from "./page/Clients/Details";

import Page_Administrators from "./page/Administrators";
import Page_Administrators_Details from "./page/Administrators/Details";

import { OpenPage } from "./services/OpenPage";

const namePage: Record<string, { title: string; subtitle?: string; btnTitle?: string }> = {
    projects: { title: 'Projects', subtitle: 'List of projects configured on the platform.', btnTitle: 'New project' },
    clients: { title: 'Clients', subtitle: 'List of clients configured on the platform.', btnTitle: 'New client' },
    administrators: { title: 'Administrators', subtitle: 'List of administrators configured on the platform.', btnTitle: 'New administrator' },
    update: { title: 'Update site', subtitle: 'Update the site configuration.', btnTitle: 'Update' },
    reports: { title: 'Reports', subtitle: 'View various reports.', btnTitle: '' },
};

export default function App() {

    const [ page, setPage ] = useState(GetStatusGlobal('page'));
    const [ logged, setLogged ] = useState(GetStatusGlobal("dashboard"));
    const [ loading, setLoading ] = useState(GetStatusGlobal("loading"));

    function CheckedPage(){
        const page = localStorage.getItem('page');
        switch (page) {
            case 'index':
                return <Page_Index />;

            case 'projects': case 'projects_details':
                return (
                    <>
                        <Page_Projects />
                        {
                            page === "projects_details" ?
                                <Page_Projects_Details />
                            : null
                        }
                    </>
                );

            case 'clients': case 'clients_details':
                return (
                    <>
                        <Page_Clients />
                        {
                            page === "clients_details" ?
                                <Page_Clients_Details />
                            : null
                        }
                    </>
                );

            case 'administrators': case 'administrators_details':
                return(
                    <>
                        <Page_Administrators />
                        {
                            page === "administrators_details" ?
                                <Page_Administrators_Details />
                            : null
                        }
                    </>
                );

            case 'updates': case 'updates_details':
                return(
                    <>
                        <Page_Update />
                        {
                            page === "updates_details" ?
                                <Page_Update_Details />
                            : null
                        }
                    </>
                );

            case 'reports':
                return <Page_Reports />;

            default:
                return <Page_Index />;
        }
    }

    useEffect(()=>{
        CheckedLogin();

        RegisterStatusGlobal("dashboard", setLogged);
        RegisterStatusGlobal("loading", setLoading);
        RegisterStatusGlobal("page", setPage);
    }, []);

    useEffect(()=>{
        setLogged(GetStatusGlobal("dashboard"));
    }, [GetStatusGlobal("dashboard")]);

    useEffect(()=>{
        setLoading(GetStatusGlobal("loading"));
    }, [GetStatusGlobal("loading")]);

    return (
        <div className="Content">
            {
                loading ?
                    <Comp_Loading />
                : null
            }
            {
                logged ? 
                    <>
                        <Page_Sidebar />

                        <div className="page_content">
                            <Comp_Header />

                            <div className="show_data_content">
                                <Comp_PageName 
                                    title={ namePage[localStorage.getItem('page')?.split('_')[0] as string]?.title ?? '' }
                                    subtitle={ namePage[localStorage.getItem('page')?.split('_')[0] as string]?.subtitle ?? '' }
                                    btn_title={ namePage[localStorage.getItem('page')?.split('_')[0] as string]?.btnTitle ?? '' }
                                    btn_function={ () => { OpenPage((localStorage.getItem('page')?.split('_')[0] as string) + '_details', 0); } } 
                                />

                                { CheckedPage() }
                            </div>
                        </div>

                        <PopUp_ShowFile />
                        <PopUp_ReturnResponse />
                        <PopUp_Confirmation />
                        <PopUp_InfGraffic />
                        <PopUp_UpdateSite />
                        <PopUp_ListVersion />
                        <PopUp_CreationTime />
                        <PopUp_ZoomMap />
                        <PopUp_GraphData />
                    </>
                :
                <Page_Login />
            }

            <Tooltip id="show_alert" style={{ backgroundColor: "#EDA13F", color: "#242527" }} />
        </div>
    );
}
